<template></template>

<script>
export default {};
(function () {
	if (document.getElementById('header')) {
		var headerElement = document.getElementById('header');
		var headerDropdowns = document.querySelectorAll('[data-header-dropdown]');
		var searchOpeners = document.querySelectorAll('[data-header-search]');
		Array.prototype.forEach.call(headerDropdowns, function (el) {
			var closer = document.createElement('span');
			closer.className = 'HeaderBeta-dropdown-closer';
			closer.setAttribute('data-header-closer', true);
			el.appendChild(closer);
		});
		var headerClosers = document.querySelectorAll('[data-header-closer]');
		Array.prototype.forEach.call(headerClosers, function (el) {
			el.addEventListener('click', function (e) {
				e.stopPropagation();
				headerElement.focus();
				//console.log('Shifted focus back to header.');
			});
		});
		Array.prototype.forEach.call(searchOpeners, function (el) {
			var searchId = el.getAttribute('data-header-search-id');
			el.addEventListener('click', function () {
				document.getElementById(searchId).focus();
				//console.log('Shifted focus to search.');
			});
		});
		// listen for escape key: close panels by moving focus
		headerElement.addEventListener('keydown', function (e) {
			if (e.key === 'Escape') {
				e.preventDefault();
				headerElement.focus();
			}
		});
	}
})();
</script>

<style lang="scss">
// --------------------------------------------------------------------------
// Header styles
//
// For a11y, nothing in the header or navigation is hidden or display:none
// Instead, things are visually hidden, but still tabable and focusable
// When focused, they are visually shown
// --------------------------------------------------------------------------

// Mixins to set up item colors
// ----------------------------------------------------------------

// Styles for non-link items
@mixin headerItemColor {
	color: $color-neutral-5;
}
@mixin headerItemColorReverse {
	color: $color-neutral-0;
}

// Styles for linked items ----------------
@mixin headerLinkColor {
	color: $color-link;
	background-color: transparent;
	&:hover,
	&:focus,
	&:active {
		color: $color-link-hover;
		background-color: $color-primary-0;
	}
}
@mixin headerLinkColorNeutral {
	color: $color-text;
	background-color: transparent;
	&:hover,
	&:focus,
	&:active {
		color: $color-text;
		background-color: $color-primary-0;
	}
}
@mixin headerLinkColorNeutralLight {
	color: $color-neutral-4;
	background-color: transparent;
	&:hover,
	&:focus,
	&:active {
		color: $color-neutral-5;
		background-color: $color-neutral-0;
	}
}
@mixin headerLinkColorActive {
	background-color: $color-primary-0;
	&:hover,
	&:focus,
	&:active {
		background-color: $color-primary-0;
	}
}
@mixin headerLinkColorInactive {
	@include headerLinkColorNeutral;
	pointer-events: none;
	&:hover,
	&:focus,
	&:active {
		background-color: transparent;
	}
}

@mixin headerLinkColorReverse {
	color: $color-link-reverse;
	&:hover,
	&:focus,
	&:active {
		color: $color-link-hover-reverse;
		background-color: $color-primary-5;
	}
}
@mixin headerLinkColorNeutralReverse {
	color: $color-white;
	background-color: transparent;
	&:hover,
	&:focus,
	&:active {
		color: $color-white;
		background-color: $color-primary-5;
	}
}
@mixin headerLinkColorNeutralLightReverse {
	color: $color-neutral-0;
	background-color: transparent;
	&:hover,
	&:focus,
	&:active {
		color: $color-white;
		background-color: $color-primary-5;
	}
}
@mixin headerLinkColorActiveReverse {
	background-color: $color-primary-5;
	&:hover,
	&:focus,
	&:active {
		background-color: $color-primary-5;
	}
}
@mixin headerLinkColorInactiveReverse {
	@include headerLinkColorNeutralReverse;
	pointer-events: none;
	&:hover,
	&:focus,
	&:active {
		background-color: transparent;
	}
}

// Styles for links styled as buttons ----------------
@mixin headerLinkColorButtonStyles {
	font-weight: bold;
	margin-right: $space-sm;
}
@mixin headerLinkColorButtonPrimary {
	color: $color-white;
	background-color: $color-primary-3;
	&:hover,
	&:focus,
	&:active {
		color: $color-white;
		background-color: $color-primary-4;
	}
}
@mixin headerLinkColorButtonSecondary {
	color: $color-white;
	background-color: $color-secondary-3;
	&:hover,
	&:focus,
	&:active {
		color: $color-white;
		background-color: $color-secondary-4;
	}
}
@mixin headerLinkColorButtonAlert {
	color: $color-white;
	background-color: $color-alert-3;
	&:hover,
	&:focus,
	&:active {
		color: $color-white;
		background-color: darken($color-alert-3, 5%);
	}
}

// Styles for panels ----------------
@mixin headerPanelColor {
	background-color: $color-neutral-0;
}
@mixin headerPanelColorReverse {
	background-color: $color-neutral-5;
}

// Mixins to set up items and links styles
// ----------------------------------------------------------------

// Generic item styles ----------------
@mixin headerItem {
	@include text(3);
	@include inset-sm;
	@include headerItemColor;
	display: inline-flex;
	align-items: center;
	border-radius: $radius-sm;
	margin-right: $space-xxs;
	.Icon {
		@include icon-sm;
	}
	& > * {
		&:not(:last-child) {
			@include inline-xs;
		}
	}
	&--sm {
		@include breakpoint(medium) {
			@include text(2);
			@include inset-squish-sm;
		}
	}
	&--lg {
		@include breakpoint(medium) {
			@include text(4);
		}
	}
	&--bold {
		font-weight: bold;
	}
}
@mixin headerItem--reverse {
	@include headerItemColorReverse;
}
@mixin headerItem--inMenu {
	width: 100%;
	border-radius: 0;
}

// Link styles ----------------
@mixin headerLink {
	@include headerLinkColor;
	&--neutral {
		@include headerLinkColorNeutral;
	}
	&--neutralLight {
		@include headerLinkColorNeutralLight;
	}
	&--active {
		@include headerLinkColorActive;
	}
	&--inactive {
		@include headerLinkColorInactive;
	}
	&--buttonPrimary {
		@include headerLinkColorButtonPrimary;
		@include headerLinkColorButtonStyles;
	}
	&--buttonSecondary {
		@include headerLinkColorButtonSecondary;
		@include headerLinkColorButtonStyles;
	}
	&--buttonAlert {
		@include headerLinkColorButtonAlert;
		@include headerLinkColorButtonStyles;
	}
}

@mixin headerLink--reverse {
	@include headerLinkColorReverse;
	&--neutral {
		@include headerLinkColorNeutralReverse;
	}
	&--neutralLight {
		@include headerLinkColorNeutralLightReverse;
	}
	&--active {
		@include headerLinkColorActiveReverse;
	}
	&--inactive {
		@include headerLinkColorInactiveReverse;
	}
	&--buttonPrimary {
		@include headerLinkColorButtonPrimary;
	}
	&--buttonSecondary {
		@include headerLinkColorButtonSecondary;
	}
	&--buttonAlert {
		@include headerLinkColorButtonAlert;
	}
}

@mixin headerLink--inMenu {
	@include headerLinkColor;
	margin-right: 0;
	background-color: white;
	&--neutral {
		@include headerLinkColorNeutral;
		background-color: white;
	}
	&--neutralLight {
		@include headerLinkColorNeutralLight;
		background-color: white;
	}
	&--active {
		@include headerLinkColorActive;
	}
	&--inactive {
		@include headerLinkColorInactive;
		background-color: white;
	}
	&--buttonPrimary {
		@include headerLinkColorButtonPrimary;
	}
	&--buttonSecondary {
		@include headerLinkColorButtonSecondary;
	}
	&--buttonAlert {
		@include headerLinkColorButtonAlert;
	}
}

@mixin headerLink--inMenu--reverse {
	@include headerLinkColorReverse;
	background-color: $color-black;
	&--neutral {
		@include headerLinkColorNeutralReverse;
		background-color: $color-black;
	}
	&--neutralLight {
		@include headerLinkColorNeutralLightReverse;
		background-color: $color-black;
	}
	&--active {
		@include headerLinkColorActiveReverse;
	}
	&--inactive {
		@include headerLinkColorInactiveReverse;
		background-color: $color-black;
	}
	&--buttonPrimary {
		@include headerLinkColorButtonPrimary;
	}
	&--buttonSecondary {
		@include headerLinkColorButtonSecondary;
	}
	&--buttonAlert {
		@include headerLinkColorButtonAlert;
	}
}

// Panel styles ----------------
@mixin headerPanel {
	@include dropshadow-2;
	@include headerPanelColor;
	min-width: 12rem;
	display: flex;
	flex-direction: column;
	align-items: stretch;
	.HeaderBeta-link {
		width: 100%;
		@include stack-xxs;
		border-radius: 0;
	}
	li {
		@include stack-xxs;
		.HeaderBeta-link {
			width: 100%;
			margin: 0;
			border-radius: 0;
		}
	}
}

@mixin headerPanelDropdown {
	@include headerPanel;
	position: absolute;
	top: 100%;
	left: 0;
	min-width: 12rem;
}

@mixin headerPanelDropdown--right {
	left: auto;
	right: 0;
}

/* ----------------------------------------------------------------
	Invisible click targets to close panels, added by js
---------------------------------------------------------------- */

@mixin headerDropdownCloser {
	display: none;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	margin: 0;
}

/* ----------------------------------------------------------------
	Core block styles
---------------------------------------------------------------- */

.HeaderBeta-item {
	@include headerItem;
}

.HeaderBeta-link {
	@include headerItem;
	@include headerLink;
}

.HeaderBeta-menu-closer {
	@include headerItem;
}
.HeaderBeta-search-closer {
	@include headerItem;
}
.HeaderBeta-group {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	&[hidden] {
		display: none;
	}
	.HeaderBeta-group-heading {
		@include visuallyHidden;
		margin: 0;
		cursor: pointer;
		font-weight: normal;
		&--hideLabel {
			span:not(.HeaderBeta-dropdown-closer) {
				@include visuallyHidden;
			}
		}
		&--md-hideLabel {
			@include breakpoint(medium) {
				span {
					@include visuallyHidden;
				}
			}
		}
	}
	ul.HeaderBeta-group-list {
		list-style: none;
		margin: 0;
		display: flex;
		li {
			display: flex;
			align-items: center;
		}
	}
	.Suggest {
		max-width: 100%;
		width: 16rem;
		&--sm {
			width: 14rem;
		}
		@include breakpoint(medium, down) {
			display: none;
		}
	}
}

.HeaderBeta-group--dropdown {
	position: relative;
	align-self: center;
	.HeaderBeta-group-heading {
		@include overrideVisuallyHidden;
		@include headerItem;
		@include headerLink;
		@include headerLinkColorNeutralLight;
		// Hidden element to close dropdown by clicking on the heading
		.HeaderBeta-dropdown-closer {
			@include headerDropdownCloser;
		}
	}
	ul.HeaderBeta-group-list {
		@include visuallyHidden;
		li {
			.HeaderBeta-link {
				@include headerItem--inMenu;
				@include headerLink--inMenu;
			}
		}
	}
	@include breakpoint(medium) {
		&:focus-within {
			ul.HeaderBeta-group-list {
				@include overrideVisuallyHidden;
				@include headerPanelDropdown;
			}
			.HeaderBeta-group-heading .HeaderBeta-dropdown-closer {
				display: inline-block; // unhide closer
			}
		}
	}
	// hover is for IE11 which does not support focus-within
	@media all and (-ms-high-contrast: none), (-ms-high-contrast: none) {
		&:hover {
			ul.HeaderBeta-group-list {
				@include overrideVisuallyHidden;
				@include headerPanelDropdown;
			}
			.HeaderBeta-group-heading .HeaderBeta-dropdown-closer {
				display: inline-block; // unhide closer
			}
		}
	}
	// also for Edge 15-18 (non-chromium)
	@supports (display: -ms-grid) {
		&:hover {
			ul.HeaderBeta-group-list {
				@include overrideVisuallyHidden;
				@include headerPanelDropdown;
			}
			.HeaderBeta-group-heading .HeaderBeta-dropdown-closer {
				display: inline-block; // unhide closer
			}
		}
	}
}

.HeaderBeta-group--right {
	margin-left: auto;
	flex-wrap: wrap-reverse;
	justify-content: flex-end;
	&.HeaderBeta-group--dropdown,
	.HeaderBeta-group--dropdown {
		ul.HeaderBeta-group-list {
			@include headerPanelDropdown--right;
		}
	}
}

.HeaderBeta-group--md-first {
	@include breakpoint(medium) {
		order: -1;
	}
}

.HeaderBeta-group--md-last {
	@include breakpoint(medium) {
		order: 1;
	}
}

/* ----------------------------------------------------------------
	Structural styles
---------------------------------------------------------------- */

.HeaderBeta {
	display: flex;
	flex-wrap: wrap;
	position: relative;
	@include text(3);
	background-color: $color-white;
	max-width: 100%;
	z-index: 100;
	@include breakpoint(medium) {
		flex-wrap: nowrap;
	}
}

// Identity is a wrapper for logos and/or headings
.HeaderBeta-identity {
	@include inline-xs;
	display: flex;
	.HeaderBeta-identity-logo {
		display: inline-flex;
		align-items: center;
		flex-shrink: 0;
		max-width: 100%;
		@include inset-sm;
		@include breakpoint(large) {
			@include inset-md;
		}
		&--separated {
			background-color: $color-primary-0;
		}
		&--lockup {
			flex-direction: column;
			align-items: flex-start;
			justify-content: center;
		}
	}
	.HeaderBeta-identity-heading {
		display: inline-flex;
		align-items: center;
		flex-shrink: 0;
		max-width: 100%;
		@include inset-sm;
		@include breakpoint(large) {
			@include inset-md;
		}
		.Heading {
			margin: 0;
		}
	}
}

// Main is a wrapper for all remaining (non-identity) elements
.HeaderBeta-main {
	@include inset-sm;
	display: flex;
	justify-content: flex-end;
	flex-wrap: wrap;
	flex-grow: 1;
	@include breakpoint(medium) {
		justify-content: flex-start;
	}
}

// Main search contains the mobile search button and search panel
.HeaderBeta-main-search {
	display: flex;
	align-items: center;
}

.HeaderBeta-main-search-button {
	@include headerItem;
	@include headerLink;
	position: relative;
	cursor: pointer;
	@include breakpoint(medium, down) {
		@include headerLinkColorNeutralLight;
	}
	.HeaderBeta-dropdown-closer {
		@include headerDropdownCloser;
	}
}
.HeaderBeta-main-search-panel {
	@include visuallyHidden;
	.HeaderBeta-search-closer {
		@include headerItem--inMenu;
		justify-content: flex-end;
		display: flex;
	}
}
.HeaderBeta-main-search-button:focus-within + .HeaderBeta-main-search-panel,
.HeaderBeta-main-search-panel:focus-within {
	overflow: visible !important;
	@include overrideVisuallyHidden;
	display: flex;
	flex-direction: column;
	@include inset-md;
	@include headerPanelColor;
	@include dropshadow-2;
	z-index: 999;
	position: absolute;
	top: 100%;
	right: 0;
	bottom: auto;
	left: 0;
}
.HeaderBeta-main-search:focus-within .HeaderBeta-dropdown-closer {
	display: inline-block;
}

// hover is for IE11 which does not support focus-within
// barely works here because the panel is positioned away from the button
// so you need to move the cursor very fast
@media all and (-ms-high-contrast: none), (-ms-high-contrast: none) {
	.HeaderBeta-main-search-button:hover + .HeaderBeta-main-search-panel,
	.HeaderBeta-main-search-panel:hover {
		@include overrideVisuallyHidden;
		display: flex;
		flex-direction: column;
		@include inset-md;
		@include headerPanelColor;
		@include dropshadow-2;
		z-index: 999;
		position: absolute;
		top: 100%;
		right: 0;
		bottom: auto;
		left: 0;
	}
}
// also for Edge 15-18 (non-chromium)
@supports (display: -ms-grid) {
	.HeaderBeta-main-search-button:hover + .HeaderBeta-main-search-panel,
	.HeaderBeta-main-search-panel:hover {
		@include overrideVisuallyHidden;
		display: flex;
		flex-direction: column;
		@include inset-md;
		@include headerPanelColor;
		@include dropshadow-2;
		z-index: 999;
		position: absolute;
		top: 100%;
		right: 0;
		bottom: auto;
		left: 0;
	}
}

// Main menu contains the mobile menu button and menu panel (everything else)
.HeaderBeta-main-menu {
	display: flex;
	align-items: center;
	flex-grow: 1;
	@include breakpoint(medium, down) {
		flex-grow: 0;
	}
	.HeaderBeta-main-menu-button {
		display: none;
		@include breakpoint(medium, down) {
			display: flex;
			@include headerItem;
			@include headerLinkColorNeutralLight;
			&:focus-within + .HeaderBeta-main-menu-panel {
				transform: translateX(0%);
			}
		}
	}
	.HeaderBeta-main-menu-panel {
		@include breakpoint(medium) {
			display: flex;
		}
		flex-grow: 1;
		flex-direction: row;
		align-items: center;
		flex-wrap: wrap-reverse;
		.HeaderBeta-menu-closer {
			display: none;
		}

		@include breakpoint(medium, down) {
			@include headerPanel;
			display: block; // needed for iOS (?)
			flex-wrap: nowrap;
			position: fixed;
			top: 0;
			bottom: 0;
			right: 0;
			transform: translateX(100%);
			width: 16rem;
			max-width: calc(100vw - 2rem);
			z-index: 100;
			transition: transform 200ms ease-in-out;
			overflow-y: auto;
			// visible only when focused
			&:focus-within {
				transform: translateX(0%);
			}
			.HeaderBeta-menu-closer {
				@include headerItem--inMenu;
				justify-content: flex-end;
				display: flex;
			}

			// Group inside of main menu panel
			.HeaderBeta-group,
			.HeaderBeta-group--right,
			.HeaderBeta-group--dropdown {
				flex-direction: column;
				align-self: stretch;
				margin: 0;
				.HeaderBeta-group-heading {
					&:not(.is-visuallyHidden) {
						@include overrideVisuallyHidden;
						width: 100%;
						span {
							@include overrideVisuallyHidden;
						}
					}
					@include headerItem;
					@include headerItem--inMenu;
					@include headerLinkColorInactive;
					@include text(2);
					@include inset-sm;
					padding-top: $space-sm;
					font-weight: normal;
					text-transform: uppercase;
					.Icon {
						display: none;
					}
					span {
						text-align: left;
					}
				}
				ul.HeaderBeta-group-list {
					@include overrideVisuallyHidden;
					@include headerPanel;
					box-shadow: none;
					background-color: transparent;
					width: 100%;
					li {
						.HeaderBeta-link {
							@include headerItem--inMenu;
							@include headerLink--inMenu;
						}
					}
				}
			}
		}
	}
}

// Two Rows variant for header main menu panel - creates two rows in main-menu area
.HeaderBeta-main-menu--twoRows {
	@supports (display: grid) {
		@include breakpoint(medium) {
			.HeaderBeta-main-menu-panel {
				display: grid;
				grid-template-columns: auto;
				grid-template-rows: auto auto;
				grid-auto-flow: row;
				grid-row-gap: $space-xs;
				.HeaderBeta-group--topRow {
					grid-row: 1/2;
					grid-column: 1/3;
				}
				.HeaderBeta-group--bottomRow {
					grid-row: 2/3;
					grid-column: 1/3;
				}
			}
		}
	}
}

/* --------------------------------
	Variant styles
-------------------------------- */

// Reverse variant - for dark backgrounds
.HeaderBeta--reverse {
	background-color: $color-black;
	.HeaderBeta-item {
		@include headerItem--reverse;
	}
	.HeaderBeta-main-search {
		.HeaderBeta-main-search-button {
			@include headerItem--reverse;
			@include headerLink--reverse;
			@include breakpoint(medium, down) {
				@include headerLinkColorNeutralLightReverse;
			}
		}
	}
	.HeaderBeta-main-menu {
		.HeaderBeta-main-menu-button {
			@include headerLinkColorNeutralLightReverse;
		}
		.HeaderBeta-main-menu-panel {
			@include headerPanelColorReverse;
			@include breakpoint(medium) {
				background-color: transparent;
			}
		}
	}
	.HeaderBeta-menu-closer {
		@include headerItem--reverse;
	}
	.HeaderBeta-search-closer {
		@include headerItem--reverse;
	}
	.HeaderBeta-link {
		@include headerLink--reverse;
	}
	.HeaderBeta-group--dropdown {
		.HeaderBeta-group-heading {
			@include headerLinkColorNeutralLightReverse;
		}
		ul.HeaderBeta-group-list {
			@include headerPanelColorReverse;
			li {
				.HeaderBeta-link {
					@include headerLink--inMenu--reverse;
				}
			}
		}
		.HeaderBeta-group-heading:focus-within + ul.HeaderBeta-group-list,
		ul.HeaderBeta-group-list {
			@include headerPanelColorReverse;
		}
	}
	.HeaderBeta-main-menu {
		.HeaderBeta-main-menu-panel {
			@include breakpoint(medium, down) {
				@include headerPanelColorReverse;
				.HeaderBeta-group,
				.HeaderBeta-group--right,
				.HeaderBeta-group--dropdown {
					.HeaderBeta-group-heading {
						@include headerLinkColorNeutralLightReverse;
					}
					ul.HeaderBeta-group-list {
						li {
							.HeaderBeta-link {
								@include headerLink--inMenu--reverse;
							}
						}
					}
				}
			}
		}
	}
}

// sticky variant
.HeaderBeta--sticky {
	position: sticky;
	top: 0;
}

// No wrap variant
.HeaderBeta--noWrap {
	flex-wrap: nowrap;
}

// Split variant - adds a pseudo row across the top
// for separating out certain items
.HeaderBeta--split {
	--splitHeight: 2.5rem;
	--splitColor: #{$color-primary-0};
	@include breakpoint(medium) {
		padding-top: 2.5rem; //fallback
		padding-top: var(--splitHeight);
		&:before {
			content: '';
			position: absolute;
			background-color: $color-primary-0; //fallback
			background-color: var(--splitColor);
			width: 100%;
			top: 0;
			height: 2.5rem; //fallback
			height: var(--splitHeight);
		}
		.HeaderBeta-identity-logo--splitTop {
			position: absolute;
			top: 0;
			left: 0;
			@include inset-sm;
			height: 2.5rem; //fallback
			height: var(--splitHeight);
		}
		.HeaderBeta-group--splitTopLeft {
			position: absolute;
			top: 0;
			left: $space-sm;
			height: 2.5rem; //fallback
			height: var(--splitHeight);
		}
		.HeaderBeta-group--splitTopRight {
			position: absolute;
			top: 0;
			right: $space-sm;
			height: 2.5rem; //fallback
			height: var(--splitHeight);
		}
	}
}
</style>
